module.exports = __webpack_public_path__ + "img/img_jianjie.b7bacf6b.jpg";